<template>
  <v-container class="mt-10">
    <!-- Page Header -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1 class="text-center text-h4 font-weight-bold">
          Submit Your Infrastructure Needs and Concerns!
        </h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <!-- InfraHub Section -->
      <v-col cols="12" md="8">
        <v-card class="elevation-3 pa-4">
          <v-card-title class="text-h5 font-weight-bold">InfraHub</v-card-title>
          <v-card-text class="mt-2">
            <p>
              InfraHub is a smartphone app available both in iOS and Droid that
              allows users to register transportation infrastructure issues
              (with an emphasis on bicycle and pedestrian facilities) or needs.
              It is developed by Geoge Mason University with a support from
              Virginia Department of Transportation. It aims at providing an
              easy-to-use tool to make people's voice heard anytime and anywhere
              and to inform agencies about facility needs for better decision
              making.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Download Section -->
    <v-row justify="center" class="mt-10">
      <v-col cols="12" md="8">
        <v-card class="elevation-3 pa-4 text-center">
          <v-card-title class="text-h5 font-weight-bold">Download Our App</v-card-title>
          <v-card-text class="mt-2">
            Get the best experience on your mobile device! Download our app now.
          </v-card-text>

          <v-row justify="center">
            <v-col cols="12" sm="6">
              <v-btn
                block
                color="black"
                class="mb-3"
                href="https://apps.apple.com/us/app/infrahub/id1460921370"
                target="_blank"
              >
                <v-icon left style="color: white;">mdi-apple</v-icon> 
                <span style="color: white;">Download on the App Store</span>
              </v-btn>
            </v-col>

            <v-col cols="12" sm="6">
              <v-btn
                block
                color="green"
                href="https://play.google.com/store/apps/details?id=com.example.app"
                target="_blank"
              >
                <v-icon left>mdi-google-play</v-icon> Get it on Google Play
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    learnMore() {
      alert("More details coming soon!");
    },
  },
};
</script>

<style scoped>
h1 {
  color: #052477;
}
</style>
